import React, { useEffect } from 'react';
import { modalId } from './../common';
import Modal from './Modal';

const Dropdown = ({field, options, selected, disabled=[], blank, blank_label, options_modal, hide, note, changeHandler, customInputHandler}) => {
  let classes = field.inline ? 'group inline' : 'group';
  classes = hide ? classes + ' visuallyhidden' : classes;
  classes = disabledOptionSelected(selected, disabled) ? classes + ' warning' : classes;
  classes = note ? classes + ' note' : classes;
  classes = options_modal ? classes + ' has-options' : classes;
  classes = field.tooltip ? classes + ' has-tooltip' : classes;
  
  let custom = field.custom;
  let custom_label = field.custom_label ? field.custom_label : 'Custom';

  useEffect(() => {
    if (field.name === 'interior_exterior') {
      const urlParams = new URLSearchParams(window.location.search);
      const appIds = urlParams.get('application')?.split(',').map(Number) || [];
      const has381 = appIds.includes(381); // fire
      const has383 = appIds.includes(383); // interior
      const has380 = appIds.includes(380); // exterior
      const value = has381 ? 'Fire Door' : has383 ? 'Interior Door' : has380 ? 'Exterior Door' : '';
      if (value) changeHandler({ target: { value } });
    }
  }, [field.name, changeHandler]);

  return (
    <div className={classes}>
      <label htmlFor={field.name}>{field.label}</label>
    
      <div className="select">
        <select name={field.name} value={selected ? selected : ""} onChange={changeHandler}>

          <option key="blank" value="" disabled>{field.label}</option> : null

          {blank_label ?
            <option key={field.blank_label} value={blank_label} disabled={disabledOptionSelected(blank_label, disabled)}>{blank_label}</option> : null
          }
          {options.map(function(option) {
            return (
              <option key={option.id} value={option.value} disabled={disabledOptionSelected(option.value, disabled)}>{option.displayName}{option.price ? ' ('+option.price+')' : null}</option>
            );
          })}
          {(custom) ?
            <option key="custom" value={custom_label} disabled={disabledOptionSelected(custom_label, disabled)}>{custom_label}</option> : null
          }
        </select>
      </div>
      

      {options_modal ?
        <button type="button" className="btn" title="" data-bs-toggle="modal" data-bs-target={'#'+modalId(field.name)}>
          <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.49264 4.63537C3.67598 4.63537 4.63527 3.67608 4.63527 2.49273C4.63527 1.30939 3.67598 0.350098 2.49264 0.350098C1.3093 0.350098 0.350006 1.30939 0.350006 2.49273C0.350006 3.67608 1.3093 4.63537 2.49264 4.63537Z" stroke="#041604" stroke-width="0.7" stroke-miterlimit="10"/>
</svg>
<svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.3403 0.350098C4.25284 0.350098 2.11154 1.55828 0.425827 3.97463C0.377711 4.04436 0.351343 4.12679 0.350056 4.2115C0.348768 4.29621 0.37262 4.3794 0.418596 4.45056C1.71382 6.47803 3.82646 8.06358 6.3403 8.06358C8.82683 8.06358 10.9829 6.47321 12.2805 4.44119C12.3254 4.37142 12.3493 4.29021 12.3493 4.20724C12.3493 4.12427 12.3254 4.04306 12.2805 3.97329C10.9799 1.96457 8.80808 0.350098 6.3403 0.350098Z" stroke="#041604" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        </button> : null
      }
            
      {field.tooltip ?
        <a tabIndex="0" role="button" data-bs-trigger="focus" className="btn tooltip" data-bs-toggle="popover" data-bs-placement="right" data-bs-html="true" data-bs-title="Tool Tip:" data-bs-content={field.tooltip}>?</a> : null
      }
      
      {field.options_modal ?
        <Modal key={field.name} title={field.modal_title} field={field} options={options} disabledOptions={disabled} blank_label /> : null
      }
      
      {(custom && selected === custom_label) ?
        <input className="custom" type="text" value={field.custom_value} placeholder={custom_label} onChange={customInputHandler} /> : null
      }
      
      {note ?
        <small>{note}</small> : null
      }
    </div>
  );
};

export default Dropdown;

function disabledOptionSelected(selected, disabled) {
  return disabled.indexOf(selected) > -1;
}